/**
 * CaseManageSlice Core Reducers
 * 
 * Core CRUD operations for the case manage entity.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { CaseManageView } from '../../types/caseManageTypes';
import { CaseManageSliceState } from '../state';

// =============================================================================
// CORE REDUCERS
// =============================================================================

/**
 * Update the current case with partial data
 */
export const updateCaseManage: CaseReducer<CaseManageSliceState, PayloadAction<Partial<CaseManageView>>> = (
  state,
  action
) => {
  if (state.currentCase) {
    state.currentCase = { ...state.currentCase, ...action.payload };
    state.isEdited = true;
    // Add all updated fields to editedFields
    Object.keys(action.payload).forEach((field) => {
      if (!state.editedFields.includes(field)) {
        state.editedFields.push(field);
      }
    });
  }
};

/**
 * Reset/clear the current case
 */
export const resetCase: CaseReducer<CaseManageSliceState> = (state) => {
  state.currentCase = null;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};
